const ResetFiltersEnum = Object.freeze({
  Čeština: 'Obnovení filtrů',
  Deutsch: 'Filter zurücksetzen',
  Français: 'Réinitialiser les filtres',
  Slovenčina: 'Obnoviť filtre',
  Español: 'Restablecer filtros',
  English: 'Reset Filters',
})

export default ResetFiltersEnum
